import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useDeleteTransaction({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({ id, all = false }: { id: number; all: boolean }) => {
    const response = await httpClient.delete(
      `/team/cash-flow/transactions/${id}`,
      {
        params: { all: all ? 1 : 0 },
      },
    )
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Transaction deleted')
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
    },
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
